export const faqs = [
  {
    q: "What is the Autism Communication Support Blueprint™?",
    a: [
      "It’s a digital educational collection containing six practical volumes and five specialized bonuses focused on organizing communication observations, AAC planning considerations, visual communication resources, everyday communication opportunities, and collaborative documentation.",
      "The collection is designed to provide structured reference materials that professionals can adapt to individualized support planning.",
    ],
  },
  {
    q: "Who is this collection designed for?",
    a: [
      "The materials are primarily intended for speech-language pathologists, special education professionals, AAC and communication support professionals, early intervention professionals, educators working with autistic children, and communication support teams.",
      "Families and caregivers may also find selected resources useful when working collaboratively with qualified professionals.",
    ],
  },
  {
    q: "Is this collection appropriate for every autistic child?",
    a: [
      "No single communication resource is appropriate for every child.",
      "The materials are intended to be adapted according to individual strengths, preferences, communication needs, access requirements, and professional recommendations. The collection does not prescribe one communication method for all autistic children.",
    ],
  },
  {
    q: "Does the collection include AAC resources?",
    a: [
      "Yes. The collection includes educational frameworks, communication board planning templates, vocabulary organization resources, and materials related to AAC planning and implementation.",
      "It does not replace individualized AAC assessment or professional system-selection processes.",
    ],
  },
  {
    q: "Can I use these materials in schools, clinics, and home settings?",
    a: [
      "The resources include examples relevant to different environments. You can adapt the planning materials to your professional context while respecting applicable policies, licensing terms, and individualized communication needs.",
    ],
  },
  {
    q: "Is this a clinical certification program?",
    a: [
      "No. This is an educational digital resource collection. It does not provide professional certification, licensure, or a validated clinical qualification.",
    ],
  },
  {
    q: "How will I receive the materials?",
    a: [
      "The collection is delivered digitally. Once your purchase is completed, you’ll receive instructions for accessing your materials.",
    ],
  },
  {
    q: "Can I download the materials?",
    a: [
      "The collection is intended for digital use. Specific download and printing permissions depend on the final delivery format and product license.",
    ],
  },
  {
    q: "Is this a recurring subscription?",
    a: [
      "No. The Autism Communication Support Blueprint™ is available for a one-time payment of $27 USD. There is no monthly subscription.",
    ],
  },
  {
    q: "Can I purchase the collection outside the United States?",
    a: [
      "Yes. The collection is intended for an international English-speaking audience. Your checkout automatically converts the price to your local currency; local payment options depend on the checkout provider.",
      "The educational materials should be adapted to applicable professional standards and regulations in your location.",
    ],
  },
  {
    q: "What is your refund policy?",
    a: ["Please review the purchase terms displayed during checkout."],
  },
  {
    q: "Will these resources guarantee communication improvements?",
    a: [
      "No. Communication outcomes depend on many individual and environmental factors.",
      "The collection provides educational planning resources and does not guarantee specific developmental, therapeutic, or communication outcomes.",
    ],
  },
];
